<template>
    <div class="top-bar">
      <span class="title">开心核桃后台管理系统</span>
      <span class="login-out" @click="logOut">退出</span>
      <span class="name">{{username}}</span>
      <img src="./img/avatar.jpeg" alt="" class="avatar">
    </div>
</template>


<script>
    export default {
      data(){
        return{
          username:localStorage.getItem('username')
        }
      },
      methods:{
        logOut(){
          localStorage.clear();
          this.$router.push('/login');
        }
      }
    }
</script>

<style lang="stylus" rel="stylesheet/stylus">
.top-bar
  position:relative;
  width:100%;
  height:52px;
  background-color:#3a3c48;
  .title
    position:absolute;
    top:0;
    left:38px;
    font-size:18px;
    color: rgb(255, 208, 75);
    line-height:52px;
  .avatar
    float:right;
    margin:11px 16px;
    width:30px;
    height:30px;
    background-color:#fff;
    border-radius:50%;
  .name
    float:right;
    margin-right:40px;
    font-size:14px;
    color:rgba(255,255,255,.7);
    line-height:52px;
  .login-out
    float:right;
    margin-right:40px;
    font-size:14px;
    color:rgba(255,255,255,.7);
    line-height:52px;
    cursor:pointer;
    transition: all .3s;
  .login-out:hover
    color:#fff;



</style>



// WEBPACK FOOTER //
// src/components/TopBar/TopBar.vue